import { useState } from "react"
import { Button, Col, Container, Row, Stack } from "react-bootstrap"
import { useParams } from "react-router"
import { navigateTo } from "../../../redux/router/routerActions"
import { useAppDispatch } from "../../../redux/store"
import { useDeleteBuildingMutation, useGetBuildingByIdQuery } from "../../../services/bClientApi"

export default function DeleteBuildingPage() {
    const [deleteBuilding] = useDeleteBuildingMutation()
    const { buildingId = '' } = useParams()
    const dispatch = useAppDispatch()
    const [deleteClicked, setDeleteClicked] = useState(false)

    const {
        data,
        isLoading,
        error,
    } = useGetBuildingByIdQuery(buildingId, { skip: !buildingId || deleteClicked })

    const buildingData = data || {}


    const buildingDeleteFn = async () => {
        if (buildingId) {
            const deleteValue = await deleteBuilding(buildingId).unwrap()
            if (deleteValue) {
                dispatch(navigateTo(`/buildings/`))
            }
        }
    }

    return (
        <Container>
            <Row>
                <Col>
                    <h1>Delete Building Page</h1>
                    <hr />
                    {error && (<>{JSON.stringify(error)}<br /></>)}

                    {buildingId && buildingData && (
                        <div className="building-info">
                            {JSON.stringify(buildingData)}

                            <Stack gap={3}>
                                <div>Are you sure you want to delete Building: {buildingId}</div>
                                <div>
                                    <Button variant={'warning'} onClick={() => setDeleteClicked(true)}>Delete Building</Button>
                                </div>
                                {deleteClicked && (
                                    <div>
                                        Once you delete this building it will be gone forever. <br />
                                        <Button variant={'danger'} disabled={isLoading} onClick={() => {
                                            buildingDeleteFn()
                                        }}> Confirm Delete Building </Button>
                                    </div>
                                )}
                            </Stack>

                        </div>
                    )}
                </Col>
            </Row>
        </Container>
    )
}
